import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { IGetUserGuidedTours } from 'crono-fe-common/types/guidedTours';

export interface IPatchUserGuidedTours extends Partial<IGetUserGuidedTours> {
  resetAllForTest?: boolean;
}

export default function usePatchUserGuidedTours() {
  const queryClient = useQueryClient();

  const patchUserGuidedTours = (guidedTours: IPatchUserGuidedTours) => {
    const request: Request = {
      url: ENDPOINTS.user.guidedTours,
      config: {
        method: 'patch',
        data: {
          data: guidedTours,
        },
      },
    };

    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    Error,
    IPatchUserGuidedTours
  >(patchUserGuidedTours, {
    onSettled: () => {
      queryClient.invalidateQueries([ENDPOINTS.user.guidedTours]);
    },
  });

  return { data, mutate, ...rest };
}
